import React from "react";

import TemplatePostActions from "../../TemplatePostActions";
import InputPreview from "./InputPreview/InputPreview";

import {
  CreativeAndUploaderWrapper,
  ImageEditorOpenButton,
  UploadCloudIcon,
  UploaderWrapper
} from "./ImageVideoInputPreview.styled";

const ImageVideoInputPreview = ({ asset, assetKey }) => {
  return (
    <CreativeAndUploaderWrapper>
      <InputPreview asset={asset || "/images/bild-vorschau.png"} />
      <UploaderWrapper>
        <ImageEditorOpenButton
          onClick={() => {
            TemplatePostActions.updateShowPictureEditor(true);
            TemplatePostActions.updateSelectedCreativeKey(assetKey);
          }}
        >
          <UploadCloudIcon src="/images/icon-new__edit.svg" small={true} alt="" />
        </ImageEditorOpenButton>
      </UploaderWrapper>
    </CreativeAndUploaderWrapper>
  );
};

export default ImageVideoInputPreview;
